import { gql } from "@apollo/client";
import PastRacesFragment from "../fragments/PastRaces";
import ResultsFragment from "../fragments/PastRacesResults";

export const GET_PAST_RACES_QUERY = gql`
  query getPastRaces(
    $filterBy: PastRaceListFilter
    $wagerProfile: String!
    $byDate: Boolean!
    $byDateTrack: Boolean!
    $date: String
    $trackCode: String
    $byDateTrackNumber: Boolean!
    $raceNumber: String
    $byRunnerId: Boolean!
    $runnerId: String
  ) {
    pastRacesByDate: pastRaces(
      filter: $filterBy
      profile: $wagerProfile
      date: $date
      sort: { byPostTime: DESC }
    ) @include(if: $byDate) {
      ...pastRacesFragment
    }
    pastRacesByDateAndTrack: pastRaces(
      filter: $filterBy
      profile: $wagerProfile
      date: $date
      trackCode: $trackCode
      sort: { byPostTime: DESC }
    ) @include(if: $byDateTrack) {
      ...pastRacesFragment
      ...resultsFragment
    }
    pastRaceByDateTrackAndNumber: pastRaces(
      filter: $filterBy
      profile: $wagerProfile
      date: $date
      trackCode: $trackCode
      raceNumber: $raceNumber
      sort: { byPostTime: DESC }
    ) @include(if: $byDateTrackNumber) {
      ...pastRacesFragment
      ...resultsFragment
    }
    pastRacesByHorseId: pastRaces(
      filter: $filterBy
      profile: $wagerProfile
      sort: { byPostTime: DESC }
      entityRunnerId: $runnerId
    ) @include(if: $byRunnerId) {
      ...pastRacesFragment
      ...resultsFragment
    }
  }
  ${PastRacesFragment.entry}
  ${ResultsFragment.entry}
`;
